import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import tw from "twin.macro"

// eslint-disable-next-line consistent-return
const colorMap = hover => {
  switch (hover) {
    case "purple":
      return tw`bg-purple-800`
    case "pink":
      return tw`bg-amaranthDark`
    default:
  }
}

const Button = styled.button`
  ${tw`bg-transparent border-0 inline-flex items-center rounded-xl relative z-10`}
  background: ${props => props.color};
  transform-style: preserve-3d;
  transition: var(--transition);
  & {
    a {
      ${tw`no-underline text-neutralLight w-full h-full flex items-center px-6 py-4`}
    }

    svg {
      transition: var(--transition);
      ${tw`ml-4`}
    }

    :before {
      content: "";
      ${tw`absolute top-2 left-2 block w-full h-full rounded-xl opacity-100`}
      box-shadow: 0 0 0 1px var(--suvaGrey);
      transform: translateZ(-1px);
      transition: var(--transition);
    }

    :hover,
    :focus {
      ${props => colorMap(props.hover)}
      :before {
        content: "";
        ${tw`top-0 left-0 opacity-0`}
      }
      svg {
        ${tw`ml-8`}
      }
    }
  }
`

const ButtonPrimary = ({ children, color, hover }) => (
  <Button color={color} hover={hover}>
    {children}
  </Button>
)

ButtonPrimary.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string.isRequired,
  hover: PropTypes.string.isRequired,
}

export default ButtonPrimary
